<template>
  <v-dialog
    v-model="isOpened"
    persistent
    scrollable
    width="800px"
  >
    <v-form @submit.prevent.native="$canWrite && (submit($event))" v-if="isOpened">
      <v-card>
        <v-card-title>
          Nouvelle intervention récurrente
          <v-spacer></v-spacer>
          <v-btn icon @click="isOpened = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0" v-if="isOpened">
          <recurrent-intervention-recurrence-form class="mb-2" />
          <div class="pa-4">
            <recurrent-intervention-form
              @isValid="isValid => canSubmit = isValid"
            />
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-3 px-4">
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            color="primary darken-1"
            :loading="isAdding"
            :disabled="!$canWrite || (!canSubmit)"
          >
            Créer et programmer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import RecurrentInterventionRecurrenceForm from '@/components/RecurrentInterventions/RecurrenceForm.vue';
import RecurrentInterventionForm from '@/components/RecurrentInterventions/Form.vue';
import { mapActions } from 'vuex';

export default {
  data: () => ({
    isAdding: false,
    canSubmit: false,
  }),

  props: {
    value: Boolean,
    maker: {
      type: Object,
      required: true,
    },
    client: {
      type: Object,
      required: false,
    },
  },

  computed: {
    isOpened: {
      get() { return this.value; },
      set(isOpened) {
        return this.$emit(`input`, isOpened);
      },
    },
    hasRecurrentIntervention() {
      return Boolean(this.recurrentIntervention && this.recurrentIntervention.Maker_id);
    },
  },

  methods: {
    ...mapActions(`ui/recurrentInterventionForm`, [
      `setRecurrentIntervention`,
      `addRecurrentIntervention`,
    ]),
    initOpen() {
      this.setRecurrentIntervention({
        Maker_id: this.maker.id,
        Client_id: this.client?.id || null,
        maker: this.maker,
        client: this.client,
      });
    },
    async submit() {
      this.isAdding = true;
      await this.addRecurrentIntervention();
      this.isAdding = false;
      this.isOpened = false;
      this.$emit(`added`);
    },
  },

  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.initOpen();
      }
    },
  },

  components: {
    RecurrentInterventionRecurrenceForm,
    RecurrentInterventionForm,
  },
};
</script>

<style lang="scss" scoped>
</style>
